export const convertToUtcDate = (utcDate) => {
    return new Date(utcDate)?.toISOString()?.split('T')[0]
}

export const convertToUtcDateTime = (utcDateTime) => {
    return new Date(utcDateTime)?.toISOString().split('.')[0]
}